/** Base path when mounted under main App.js; empty when `start:demo-pos` owns `/`. */
export const DEMO_POS_BASE = process.env.REACT_APP_TARGET === 'demo-pos' ? '' : '/naturals/demo-pos';

export function demoPosPath(subpath = '') {
  const tail = String(subpath || '').replace(/^\/+/, '');
  if (!DEMO_POS_BASE) {
    return tail ? `/${tail}` : '/';
  }
  return tail ? `${DEMO_POS_BASE}/${tail}` : DEMO_POS_BASE;
}
